import DataAccess from './constants';
import { genfunction } from '../helpers';
import Moment from 'moment';

const { DefaultCostRateID } = window['runConfig'];
const path = 'tourproducts?TourProductID=';

export const apiTourProduct = (tourProductID, CostRateID) => {

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    var priceDate = Moment(new Date()).format('MM/DD/YYYY');

    const url = DataAccess.apiUrl + path + tourProductID + '&PriceDate=' + priceDate + '&CostRateID=' + DefaultCostRateID;

    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}